/**
 * This component is written specifically to support dynamoDB pagination
 * The API for dynamoDB pagination isn't the most user friendly, read up
 * on dynamoDB pagination before trying to understand the logic of this
 * file. It will make more sense.
 */

import React, { useEffect, useState } from 'react';
import { useI18n } from '~Hooks';
import { Button, Column, Columns } from '~Styles';

interface PaginationProps {
  lastKey: any;
  onUpdate: (newAfter: any) => void;
  loading?: boolean;
}

export default function Pagination({ lastKey, onUpdate, loading }: PaginationProps) {
  const { i18n } = useI18n();

  // This state is for presentation reasons only
  const [page, setPage] = useState(1);
  // [pageNumber]: lastKey that will take us to that page
  // eg: 2: {key for page 2}
  // 1 will always be empty, as the after param should be null
  const [pageKeys, setPageKeys] = useState({
    [page + 1]: lastKey,
  });

  useEffect(() => {
    setPageKeys((prev) => ({ ...prev, [page + 1]: lastKey }));
  }, [lastKey]);

  const handlePrevious = () => {
    if (page === 1) {
      return;
    }
    const newPageNumber = page - 1;
    setPage(newPageNumber);
    onUpdate(pageKeys[newPageNumber]);
  };

  const handleNext = () => {
    // If we don't have a lastKey, that means that we have reached the end of the list
    if (!lastKey) {
      return;
    }
    const newPageNumber = page + 1;
    setPage(newPageNumber);
    onUpdate(pageKeys[newPageNumber]);
  };

  return (
    <Columns style={{ marginTop: 'auto' }}>
      <Column alignItems="flex-start">
        <Button
          backgroundColor="colorBlack"
          color="colorWhite"
          padding="large"
          style={{ height: '58px' }}
          disabled={loading || page === 1}
          onTouchEnd={handlePrevious}>
          {'<'}
        </Button>
      </Column>
      <Column alignItems="center" justifyContent="center">
        <h3 style={{ margin: '0' }}>
          {i18n('GC.Pagination.Page')} {page}
        </h3>
      </Column>
      <Column alignItems="flex-end">
        <Button
          backgroundColor="colorBlack"
          color="colorWhite"
          padding="large"
          style={{ height: '58px' }}
          disabled={loading || !lastKey}
          onTouchEnd={handleNext}>
          {'>'}
        </Button>
      </Column>
    </Columns>
  );
}
